import { render, staticRenderFns } from "./dev_book.vue?vue&type=template&id=58f16054&scoped=true&"
import script from "./dev_book.vue?vue&type=script&lang=js&"
export * from "./dev_book.vue?vue&type=script&lang=js&"
import style0 from "./dev_book.vue?vue&type=style&index=0&id=58f16054&scoped=true&lang=less&"
import style1 from "./dev_book.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f16054",
  null
  
)

export default component.exports